gsap.registerPlugin(ScrollTrigger, MorphSVGPlugin);

export default () => {
    const nodeSelectors = {
        container: '[js-animation-footer="container"]',
        bouncyPath: '[js-animation-footer="bouncy-path"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        const down = 'M0-0.3C0-0.3,464,156,1139,156S2278-0.3,2278-0.3V683H0V-0.3z';
        const center = 'M0-0.3C0-0.3,464,0,1139,0s1139-0.3,1139-0.3V683H0V-0.3z';

        ScrollTrigger.create({
            trigger: nodeSelectors.container,
            start: 'top bottom',
            // markers: true,
            toggleActions: 'play pause resume reverse',
            onEnter: self => {
                const velocity = self.getVelocity();
                const variation = velocity / 10000;

                gsap.fromTo(nodeSelectors.bouncyPath, {
                    morphSVG: down
                }, {
                    duration: 2,
                    morphSVG: center,
                    ease: `elastic.out(${1 + variation}, ${1 - variation})`,
                    overwrite: 'true'
                });
            }
        });
    }

    return Object.freeze({
        init,
    })
}